export const PromiseCanceledError = new Error("Promise canceled");

function cancelablePromise(promise) {
  let isCanceled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise
      .then(val => (isCanceled ? reject(PromiseCanceledError) : resolve(val)))
      .catch(error => (isCanceled ? reject(PromiseCanceledError) : reject(error)));
  });
  return {
    promise: wrappedPromise,
    cancel() {
      isCanceled = true;
    }
  };
}

export default cancelablePromise;
